import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { withCookies, Cookies } from 'react-cookie';

import {
  sendFormRequest,
  changeFieldEmail,
  changeFieldPassword,
  changeFieldPasswordConfirm,
  changeFieldRefUserId,
  changeFieldVerifyCode,
  selectRequestState,
  selectFieldEmail,
  selectFieldPassword,
  selectFieldPasswordConfirm,
  selectFieldVerifyCode
} from 'mt-react-common/modules/users/common/reducers/forms/signUpForm';

import ButtonDefault from 'components/Common/Buttons/ButtonDefault';
import ReCaptcha from 'components/Captcha/ReCaptcha';

const signUpFormRM = 'usersModule.forms.signUpForm';

class SignUp extends Component {
  componentDidMount() {
    const refUserId = this.props.cookies.get('ref') || null;
    if (refUserId) {
      this.props.changeFieldRefUserId(refUserId);
    }
  }

  componentWillUpdate(nextProps) {
    if (
      nextProps.requestState.hasSuccessQuery !==
        this.props.requestState.hasSuccessQuery &&
      nextProps.requestState.hasSuccessQuery
    ) {
      this.props.history.replace('/');
    }
  }

  handleChangeField = async event => {
    switch (event.target.name) {
      case 'email':
        this.props.changeFieldEmail(event.target.value);
        break;
      case 'password':
        this.props.changeFieldPassword(event.target.value);
        break;
      case 'password_confirm':
        this.props.changeFieldPasswordConfirm(event.target.value);
        break;
      default:
        break;
    }
  };

  handleSubmit = async event => {
    event.preventDefault();
    this.props.sendFormRequest();
  };

  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <div
            className={`form-group ${
              hasError(this.props.selectFieldEmail.errors) ? 'has-error' : ''
            }`}
          >
            <label className="control-label sr-only" htmlFor="sing-up-email">
              E-mail
            </label>
            <input
              type="email"
              className="form-control input-lg"
              id="sing-up-email"
              placeholder="E-mail"
              name="email"
              value={this.props.selectFieldEmail.value}
              onChange={this.handleChangeField}
            />
            {errorDesc(this.props.selectFieldEmail.errors)}
          </div>
          <div
            className={`form-group ${
              hasError(this.props.selectFieldPassword.errors) ? 'has-error' : ''
            }`}
          >
            <label className="control-label sr-only" htmlFor="sing-up-password">
              Пароль
            </label>
            <input
              type="password"
              className="form-control input-lg"
              id="sing-up-password"
              placeholder="Пароль"
              name="password"
              value={this.props.selectFieldPassword.value}
              onChange={this.handleChangeField}
            />
            {errorDesc(this.props.selectFieldPassword.errors)}
          </div>
          <div
            className={`form-group ${
              hasError(this.props.selectFieldPasswordConfirm.errors)
                ? 'has-error'
                : ''
            }`}
          >
            <label
              className="control-label sr-only"
              htmlFor="sing-up-password-confirm"
            >
              Повторите пароль
            </label>
            <input
              type="password"
              className="form-control input-lg"
              id="sing-up-password-confirm"
              placeholder="Повторите пароль"
              name="password_confirm"
              value={this.props.selectFieldPasswordConfirm.value}
              onChange={this.handleChangeField}
            />
            {errorDesc(this.props.selectFieldPasswordConfirm.errors)}
          </div>
          <div
            className={`form-group ${
              hasError(this.props.selectFieldVerifyCode.errors)
                ? 'has-error'
                : ''
            }`}
          >
            <ReCaptcha
              isCheckFailValidCounterFull
              requestStateOfForm={this.props.requestState}
              changeCaptchaValue={value =>
                this.props.changeFieldVerifyCode(value)
              }
            />
            {errorDesc(this.props.selectFieldVerifyCode.errors)}
          </div>
          <ButtonDefault
            type="submit"
            className="btn btn-default btn-block btn-primary btn-lg"
            buttonTitle={'Зарегистрироваться'}
            showLoading={this.props.requestState.hasInProgress}
            disabled={this.props.requestState.hasInProgress}
          />
          <div className={'text-center'}>
            Регистрируясь, вы принимаете наши{' '}
            <Link
              style={{ color: '#2b96f1' }}
              to={`/info/polzovatelskoe_soglashenie`}
            >
              пользовательское соглашение
            </Link>
            ,{' '}
            <Link
              style={{ color: '#2b96f1' }}
              to={`/info/politika_konfidencialnosti`}
            >
              политику конфиденциальности
            </Link>{' '}
            и даете{' '}
            <Link
              style={{ color: '#2b96f1' }}
              to={`/info/soglasie_na_obrabotku_personalnih_dannih`}
            >
              согласие на обработку персональных данных
            </Link>
            .
          </div>
        </form>
      </div>
    );
  }
}

SignUp.propTypes = {
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  sendFormRequest: PropTypes.func.isRequired,
  changeFieldEmail: PropTypes.func.isRequired,
  changeFieldPassword: PropTypes.func.isRequired,
  changeFieldPasswordConfirm: PropTypes.func.isRequired,
  changeFieldRefUserId: PropTypes.func.isRequired,
  changeFieldVerifyCode: PropTypes.func.isRequired,

  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  selectFieldEmail: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  selectFieldPassword: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  selectFieldPasswordConfirm: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  selectFieldVerifyCode: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  history: PropTypes.shape().isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, signUpFormRM),
  selectFieldEmail: selectFieldEmail(state, signUpFormRM),
  selectFieldPassword: selectFieldPassword(state, signUpFormRM),
  selectFieldPasswordConfirm: selectFieldPasswordConfirm(state, signUpFormRM),
  selectFieldVerifyCode: selectFieldVerifyCode(state, signUpFormRM)
});

const mapDispatchToProps = dispatch => ({
  sendFormRequest: () => dispatch(sendFormRequest(signUpFormRM)),
  changeFieldEmail: value => dispatch(changeFieldEmail(signUpFormRM, value)),
  changeFieldPassword: value =>
    dispatch(changeFieldPassword(signUpFormRM, value)),
  changeFieldPasswordConfirm: value =>
    dispatch(changeFieldPasswordConfirm(signUpFormRM, value)),
  changeFieldRefUserId: value =>
    dispatch(changeFieldRefUserId(signUpFormRM, value)),
  changeFieldVerifyCode: value =>
    dispatch(changeFieldVerifyCode(signUpFormRM, value))
});

export default withCookies(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SignUp)
  )
);



// WEBPACK FOOTER //
// ./src/components/UserAccount/SignUp/SignUp.js